var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"status-icon"},[_c('v-tooltip',{attrs:{"top":""},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
var attrs = ref.attrs;
return [_c('v-icon',_vm._g(_vm._b({attrs:{"color":_vm.iconColor}},'v-icon',attrs,false),on),[_vm._v(_vm._s(_vm.iconName))])]}}])},[_c('span',[_vm._v(_vm._s(_vm.iconMessage))])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }